import { render, staticRenderFns } from "./ContestForm.vue?vue&type=template&id=3b11323e&scoped=true&"
import script from "./ContestForm.vue?vue&type=script&lang=ts&"
export * from "./ContestForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContestForm.vue?vue&type=style&index=0&id=3b11323e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b11323e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VTextField,VTooltip})
